import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useTheme } from "@mui/material/styles";
import {
  MyTextArea,
  MyTextInput,
} from "../services/authentication/inputServices";
import { Store } from "react-notifications-component";
import { AddJourney, getAllJourney, updateJourneyData } from "../services/web/webServices";
import Loader from "../components/Helpper/Loader";
import { Switch } from "@mui/material";
function Journeys() {
  const theme = useTheme();
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [getButton, setButton] = useState(true);
  const [getLoader, setLoader] = useState(true);
  const [select, setSelection] = useState([]);
  const [ContentRowData, setContentRowData] = useState([]);
  const [ContentSelectedId, setContentSelectedId] = useState(null);
  const [contentDetail, setContentDetail] = useState([]);
  const [showEye, setShowEye] = useState(false);
  const pageName = "Journey Management";

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const handleClose1 = () => setShowEye(false);
  const handleShow1 = (params) => {
    setContentRowData(params);
    setContentSelectedId(params.row.id);
    setShowEye(true);
  };

  const handleStatusToggle = (params) => async () => {
    const currentStatus = params.row.status;
    const newStatus = currentStatus === "active" ? "inActive" : "active";

    if (
      window.confirm(`Are you sure you want to mark this journey as ${newStatus}?`)
    ) {
      try {
        await updateJourneyData(params.row.id, { status: newStatus });

        Store.addNotification({
          title: "Success",
          message: `journey status updated to ${newStatus}`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });

        setLoader(true);
        getAllJourney()
          .then((res) => {
            const journeys = Array.isArray(res?.data?.data) ? res.data.data : [];
            setContentDetail(
              journeys.map((el, index) => ({
                ...el,
                id: el.id,
                i: index,
              }))
            );
            setLoader(false);
          })
          .catch((err) => {
            setLoader(false);
            console.log("Error while refreshing tags:", err);
          });
      } catch (error) {
        console.error("Failed to update tag status", error);
      }
    }
  };

  const columns = [
    {
      field: "sno",
      headerName: "S.NO.",
      filterable: false,
      renderCell: (index) => `${index.row.i + 1}`,
      width: 100,
    },

    {
      field: "title",
      headerName: " Journey Title",
      width: 200,
    },

    {
      field: "description",
      headerName: " Journey Description",
      width: 250,
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      renderCell: (params) => {
        const isActive = params.row.status === "active";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Switch
              checked={isActive}
              onChange={handleStatusToggle(params)}
              color="success"
            />
            <span style={{ textTransform: "capitalize" }}>
              {isActive ? "Active" : "InActive"}
            </span>
          </div>
        );
      },
    },

    {
      field: "action",
      headerName: "Action",
      width: 310,

      renderCell: (params) => {
        return (
          <>
            <Button
              style={{
                backgroundColor: "#64A433",
                border: "none",
                marginRight: "5px",
              }}
              onClick={() => handleShow1(params)}
            >
              <i className="fas fa-edit"></i>
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    setLoader(true);
    getAllJourney()
      .then((res) => {
        const journeys = Array.isArray(res?.data?.data) ? res.data.data : [];
        setContentDetail(
          journeys.map((el, index) => ({
            ...el,
            id: el.id,
            i: index,
          }))
        );
        setLoader(false);
      })

      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }, []);

  const css = `
    
.form-group {
  margin-bottom: 20px;
}

.form-control {
  width: 100%;
  padding: 8px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  
}
  .form-control-edit {
  width: 100%;
  padding: 8px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  height:110px
}


  .form-submit{
    padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;  
  border-radius: 5px;
  }
.form-submit:hover {
  background-color: #4CAF50; /* Darker green on hover */
  transform: scale(1.05); /* Slightly enlarge the button */
}

.form-submit:disabled {
  background-color: #9e9e9e; /* Grey color when disabled */
  cursor: not-allowed; /* Change cursor to not-allowed when disabled */
}
  .form-label {
  margin-bottom: 5px;
  display: block;
  font-weight: bold;
}
      .form-label {
  margin-bottom: 5px;
  display: block;
  font-weight: bold;
  color: #555659; 
}
  `;
  const [showAddPlace, setShowAddPlace] = useState(false);
  const handleCloseAddPlace = () => setShowAddPlace(false);
  return (
    <>
      <style>{css}</style>
      <div className="grid-container">

        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
        <Header OpenSidebar={OpenSidebar} pageName={pageName} />


        <div
          style={{
            gridArea: "main",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            // margin: "0 150px 150px",
            margin: "0 90px 150px",
          }}
        >
          <div style={{ marginLeft: "200px" }}>
            <Button
              style={{
                backgroundColor: "#64A433",
                border: "none",
                marginTop: "30px",
                width: "150px",
              }}
              onClick={() => setShowAddPlace(true)}
            >
              + Add Journey
            </Button>
          </div>
          <Box sx={{ height: 400, width: "100%", boxShadow: 7 }}>
            {getLoader ? (
              <Loader />
            ) : contentDetail.length > 0 ? (
              <>
                <DataGrid
                  rows={contentDetail}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  pageSizeOptions={[5, 10, 25]}
                  disableRowSelectionOnClick
                  onSelectionChange={(newSelection) => {
                    setSelection(newSelection.rows);
                  }}
                  sx={{
                    "& .MuiDataGrid-row:nth-of-type(odd)": {
                      backgroundColor: theme.palette.action.hover, // Light grey background
                    },
                    "& .MuiDataGrid-cell:last-child": {
                      border: 0, // Hide the last cell border
                    },
                  }}
                />
              </>
            ) : (
              <p style={{ fontSize: "30px", padding: "30px" }}>
                No data found.
              </p>
            )}
          </Box>
          {/* modal for view and update jorney management------------------------- */}

          <Modal show={showEye} onHide={handleClose1} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Journey Management</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{
                  title: ContentRowData?.row?.title
                    ? ContentRowData?.row?.title
                    : "",

                  title_sp: ContentRowData?.row?.title_sp
                    ? ContentRowData?.row?.title_sp
                    : "",

                  description: ContentRowData?.row?.description
                    ? ContentRowData?.row?.description
                    : "",

                  description_sp: ContentRowData?.row?.description_sp
                    ? ContentRowData?.row?.description_sp
                    : "",
                }}
                validationSchema={Yup.object({
                  title: Yup.string().required("Please Enter title")
                    .min(3, "Title must be at least 3 characters")
                    .max(50, "Title must be 50 characters or less"),
                  title_sp: Yup.string().required("Please Enter Spanish title")
                    .min(3, "Spanish title must be at least 3 characters")
                    .max(50, "Spanish title must be 50 characters or less"),
                  description: Yup.string().required(
                    "Please Enter Description"
                  ),
                  description_sp: Yup.string().required(
                    "Please Enter Description in spanish"
                  ),
                })}
                onSubmit={(values, { resetForm }) => {
                  setButton(false);

                  updateJourneyData(ContentSelectedId, values)
                    .then((res) => {
                      setButton(true);

                      Store.addNotification({
                        title: "Success",
                        message: res.data?.message,
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                          duration: 5000,
                          onScreen: true,
                        },
                      });
                      setLoader(true);
                      getAllJourney()
                        .then((res) => {
                          const journeys = Array.isArray(res?.data?.data) ? res.data.data : [];
                          setContentDetail(
                            journeys.map((el, index) => ({
                              ...el,
                              id: el.id,
                              i: index,
                            }))
                          );

                          setLoader(false);
                        })
                        .catch((err) => {
                          setLoader(false);
                          console.log(err);
                        });
                      handleClose1();
                    })
                    .catch((error) => {
                      setButton(true);
                      if (error) {
                        Store.addNotification({
                          title: "Error!",
                          message: error?.response?.data?.message,
                          type: "danger",
                          insert: "top",
                          container: "top-right",
                          animationIn: ["animate__animated", "animate__fadeIn"],
                          animationOut: [
                            "animate__animated",
                            "animate__fadeOut",
                          ],
                          dismiss: {
                            duration: 5000,
                            onScreen: true,
                          },
                        });
                      }
                    });
                }}
              >
                {(props) => (
                  <Form>
                    <div className="form-group">
                      <label className="form-label">Journey Title:</label>
                      <MyTextInput
                        type="text"
                        id="title"
                        name="title"
                        className="form-control"
                        placeholder="Enter title"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Journey Title in Spanish:</label>
                      <MyTextInput
                        type="text"
                        id="title_sp"
                        name="title_sp"
                        className="form-control"
                        placeholder="Enter title in Spanish"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Journey Description:</label>
                      <MyTextArea
                        type="text"
                        id="description"
                        name="description"
                        className="form-control-edit"
                        placeholder="Enter description"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Journey Description in Spanish:
                      </label>
                      <MyTextArea
                        type="text"
                        id="description_sp"
                        name="description_sp"
                        className="form-control-edit"
                        placeholder="Enter description in Spanish"
                      />
                    </div>
                    {getButton === true ? (
                      <Button type="submit" className="form-submit">
                        Update
                      </Button>
                    ) : (
                      <Button type="submit" className="form-submit" disabled>
                        Please Wait!!
                      </Button>
                    )}
                  </Form>
                )}
              </Formik>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose1}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>


          <Modal show={showAddPlace} onHide={handleCloseAddPlace} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Journey Management</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{
                  title: "",

                  title_sp: "",

                  description: "",

                  description_sp: "",
                }}
                validationSchema={Yup.object({
                  title: Yup.string().required("Please Enter title")
                    .min(3, "Title must be at least 3 characters")
                    .max(50, "Title must be 50 characters or less"),
                  title_sp: Yup.string().required("Please Enter Spanish title")
                    .min(3, "Spanish title must be at least 3 characters")
                    .max(50, "Spanish title must be 50 characters or less"),
                  description: Yup.string()
                    .required("Please Enter Description")
                    .min(10, "Description must be at least 10 characters"),

                  description_sp: Yup.string()
                    .required("Please Enter Description in Spanish")
                    .min(10, "Description spanish must be at least 10 characters"),
                })}
                onSubmit={(values, { resetForm }) => {
                  setButton(false);
                  console.log(values)
                  AddJourney(values)
                    .then((res) => {
                      setButton(true);
                      handleCloseAddPlace()

                      Store.addNotification({
                        title: "Success",
                        message: res.data?.message,
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                          duration: 5000,
                          onScreen: true,
                        },
                      });
                      setLoader(true);
                      getAllJourney()
                        .then((res) => {
                          const journeys = Array.isArray(res?.data?.data) ? res.data.data : [];
                          setContentDetail(
                            journeys.map((el, index) => ({
                              ...el,
                              id: el.id,
                              i: index,
                            }))
                          );

                          setLoader(false);
                        })
                        .catch((err) => {
                          setLoader(false);
                          console.log(err);
                        });
                      handleClose1();
                    })
                    .catch((error) => {
                      setButton(true);
                      if (error) {
                        Store.addNotification({
                          title: "Error!",
                          message: error?.response?.data?.message,
                          type: "danger",
                          insert: "top",
                          container: "top-right",
                          animationIn: ["animate__animated", "animate__fadeIn"],
                          animationOut: [
                            "animate__animated",
                            "animate__fadeOut",
                          ],
                          dismiss: {
                            duration: 5000,
                            onScreen: true,
                          },
                        });
                      }
                    });
                }}
              >
                {(props) => (
                  <Form>
                    <div className="form-group">
                      <label className="form-label">Journey Title:</label>
                      <MyTextInput
                        type="text"
                        id="title"
                        name="title"
                        className="form-control"
                        placeholder="Enter title"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Journey Title in Spanish:</label>
                      <MyTextInput
                        type="text"
                        id="title_sp"
                        name="title_sp"
                        className="form-control"
                        placeholder="Enter title in Spanish"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Journey Description:</label>
                      <MyTextArea
                        type="text"
                        id="description"
                        name="description"
                        className="form-control-edit"
                        placeholder="Enter description"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Journey Description in Spanish:
                      </label>
                      <MyTextArea
                        type="text"
                        id="description_sp"
                        name="description_sp"
                        className="form-control-edit"
                        placeholder="Enter description in Spanish"
                      />
                    </div>
                    {getButton === true ? (
                      <Button type="submit" className="form-submit">
                        Add Journey
                      </Button>
                    ) : (
                      <Button type="submit" className="form-submit" disabled>
                        Please Wait!!
                      </Button>
                    )}
                  </Form>
                )}
              </Formik>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseAddPlace}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default Journeys;
